<template>
    <div class="my-5 p-3 w-75">
        <div class="col-12 mb-5">
            <h2 v-html="header" class="text-white"></h2>
        </div>

        <p class="text-white pb-4" v-html="attachmentComments"></p>

        <form id="attachment" @submit.prevent="handleStoreData()" method="post" enctype="multipart/form-data">
            <div class="form-row mb-3">
                <div class="col-md-6">
                    <span data-bs-toggle="tooltip" data-bs-placement="top" :title="fileTooltip"><font-awesome-icon icon="question-circle"/> </span>
                    <label>Wybierz plik: </label>
                    <input type="file" ref="fileInput" :class="'form-control ' + (errorMessages['file'] !== null ? 'error-input' : '')"  name="file" @change="pickFile">
                    <div class="error" v-if="errorMessages['file']">
                        <ul>
                            <li v-for="error in errorMessages['file']" :key="error">{{ error }}</li>
                        </ul>
                    </div>
                </div>
                <form-select label="Typ pliku:" size="col-md-6" name="file_type" :model-value="file_type" v-model="file_type" :values="fileTypes" :error-messages="errorMessages"></form-select>
            </div>

            <div class="form-group">
                <form-textarea label="Opis pliku" name="description" rows="5" :model-value="description" v-model="description" :error-messages="errorMessages"></form-textarea>
            </div>

            <div class="form-group">
                <form-textarea label="Afiliacja:" name="affiliation" rows="3" :model-value="affiliation" v-model="affiliation" :tooltip="affiliationTooltip" :error-messages="errorMessages"></form-textarea>
            </div>

            <div class="form-row">
                <form-input label="Sesja:" size="col-md-6" type="text" name="session" :model-value="session" v-model="session" :tooltip="sessionTooltip" :error-messages="errorMessages"></form-input>
            </div>

            <p class="alert alert-success" v-if="message" v-html="message"></p>

            <div class="form-group text-center">
                <button type="submit" class="btn btn-primary btn-lg mt-4">Dodaj</button>
            </div>

            <notifications group="foo" />

        </form>
    </div>
</template>

<script>
    import FormInput from "./formInput";
    import FormSelect from "./formSelect";
    import FormTextarea from "./formTextarea";

    export default {
        props: ['header', 'modelClass', 'modelId', 'attachmentComments', 'name'],
        components: {
            FormInput,
            FormSelect,
            FormTextarea,
        },
        created() {
            this.fetchData();
        },

        data() {
            return {
                file: '',
                description: '',
                file_type: '',
                fileTypes: '',
                affiliation: '',
                session: '',
                errorMessages: '',
                fileTooltip: 'Prosimy o przesłanie pliku w formacie PDF, MS Word, PowerPoint lub jako grafikę.',
                affiliationTooltip: 'Podaj np. informacje o współautorach lub inne uwagi.',
                sessionTooltip: 'Podaj tytuł sesji lub wykładu, którego dotyczy plik.',
                message: ''
            }
        },

        methods: {
            fetchData(){
                axios.get('/api/attachment-data')
                .then((response) => {
                    this.fileTypes = response.data;
                });
            },

            handleStoreData() {
                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('description', this.description);
                formData.append('file_type', this.file_type);
                formData.append('attachmentable_id', this.modelId);
                formData.append('attachmentable_type', this.modelClass);
                formData.append('affiliation', this.affiliation);
                formData.append('session', this.session);

                axios.post('/api/attachment-data/store', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then(response => {
                    this.errorMessages = '';
                    this.file = '';
                    this.description = '';
                    this.file_type = '';
                    this.affiliation = '';
                    this.session = '';
                    this.$refs.fileInput.value = null;
                    this.$notify({
                        'group': 'foo',
                        'type': 'success',
                        'title': response.data.message,
                        'duration': 8000
                    });

                    this.message = response.data.message;
                })
                .catch(error => {
                    this.errorMessages = error.response.data.errors;
                    if(error.response.data.message) {
                        this.$notify({
                            'group': 'foo',
                            'type': 'error',
                            'title': error.response.data.message
                        })
                    }
                    window.scrollTo(0, document.querySelector('.error').offsetParent.offsetTop);
                });
            },

            pickFile(){
                this.file = this.$refs.fileInput.files[0];
            }
        }

    }
</script>
